export default "__VITE_ASSET__b771946c__"